<script>
  import { checkbox } from 'vue-strap';
  import estados from '~js/estados';
  
  export default {
    components: { checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false, 
        default: false, 
      }
    },
    data() {
      return {
        estados: estados,
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        return this.$validator.validateAll();
      },
    },
    computed: {
    },
    mounted() {
    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group required" :class="{'has-error': errors.has('enderecoCobranca')}">
          <label class="control-label" for="endereco-cobranca">Endereço</label>

          <input
            id="endereco-cobranca"
            class="form-control"
            type="text"
            v-model="solicitacao.enderecoCobranca"
            data-vv-name="enderecoCobranca"
            data-vv-as="endereço"
            v-validate="'required'"
            maxlength="200">

          <p class="text-danger" v-show="errors.has('enderecoCobranca')">{{ errors.first('enderecoCobranca') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('numeroCobranca')}">
          <label class="control-label" for="numero-cobranca">Número</label>

          <input
            id="numero-cobranca"
            class="form-control"
            type="text"
            v-model="solicitacao.numeroCobranca"
            data-vv-name="numeroCobranca"
            data-vv-as="número"
            v-validate="'required'"
            maxlength="10">

          <p class="text-danger" v-show="errors.has('numeroCobranca')">{{ errors.first('numeroCobranca') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="complemento-cobranca">Complemento</label>

          <input
            id="complemento-cobranca"
            class="form-control"
            type="text"
            v-model="solicitacao.complementoCobranca"
            maxlength="30">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group" :class="{'has-error': errors.has('bairroCobranca')}">
          <label class="control-label" for="bairro-cobranca">Bairro</label>

          <input type="text"
                 class="form-control"
                 id="bairro-cobranca"
                 v-model="solicitacao.bairroCobranca"
                 data-vv-as="bairro"
                 data-vv-name="bairroCobranca"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('bairroCobranca')">{{ errors.first('bairroCobranca') }}</p>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('cidadeCobranca')}">
          <label class="control-label" for="cidade-cobranca">Cidade</label>

          <input type="text"
                 class="form-control"
                 id="cidade-cobranca"
                 v-model="solicitacao.cidadeCobranca"
                 data-vv-as="cidade"
                 data-vv-name="cidadeCobranca"
                 v-validate="'required'"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('cidadeCobranca')">{{ errors.first('cidadeCobranca') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="paisCobranca">País</label>

          <input id="paisCobranca"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.paisCobranca"
                 maxlength="30">
        </div>
      </div>

    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento-estrangeiro-pj/componentes/compartilhado/FormDadosCobranca.vue